import PropTypes from 'prop-types';
import React from 'react';

import { SearchSkinnyIcon } from 'components/Icon';
import I18n from 'utils/I18n';

const SearchIcon = ({ searchEngagement, trackSearchEvent }) => (
  <a
    onClick={() => trackSearchEvent(searchEngagement)}
    href="/pages/search"
    className="SearchIcon__icon-search"
    aria-label={I18n.localize('topNavigation.search')}
  >
    <SearchSkinnyIcon />
  </a>
);

SearchIcon.propTypes = {
  trackSearchEvent: PropTypes.func,
  searchEngagement: PropTypes.shape({
    dyDecisionId: PropTypes.string,
    dyVariationId: PropTypes.number,
  }),
};

SearchIcon.defaultProps = {
  trackSearchEvent: () => {},
  searchEngagement: {},
};

export default SearchIcon;
